module.exports = __webpack_public_path__ + "0a9642da3df80d032acf02e5950cf889.png";